import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4 6h16v10h-4.267l1.067 2H20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h3.2l1.067-2H4z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m8.855 18.504 2.277-3.985a1 1 0 0 1 1.736 0l2.277 3.985A1 1 0 0 1 14.277 20H9.723a1 1 0 0 1-.868-1.496"
    }
  )
);
var SvgPresentFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PresentFilled_default = SvgPresentFilled;

export { PresentFilled_default as default };
